import {Component} from '@angular/core';
import {FilterConfig, GridPageComponent} from "../../../common/grid-page.component";
import {CountsPerStoreTypeGridViewDto} from "@services";
import {CommonModule} from "@angular/common";
import {
    DxDataGridModule,
    DxFormModule,
    DxTemplateModule,
    DxTabsModule
} from "devextreme-angular";
import {FilterPanelComponent} from "../../../../components/library/filter-panel/filter-panel.component";

export enum CountType {
    PalletCount = "PalletCount",
    MaterialCount = "MaterialCount",
    DistinctBinsUsed = "DistinctBinsUsed",
}

@Component({
    selector: 'app-counts-per-storage-type',
    standalone: true,
    imports: [
        CommonModule,
        DxDataGridModule,
        DxFormModule,
        DxTemplateModule,
        DxTabsModule,
        FilterPanelComponent
    ],
    templateUrl: './counts-per-storage-type.component.html',
    styles: [
        `.grid {
            height: calc(100vh - 150px);
        }`
    ]
})
export class CountsPerStorageTypeComponent extends GridPageComponent<CountsPerStoreTypeGridViewDto> {

    constructor() {
        super();
        this.init(CountsPerStoreTypeGridViewDto);
    }

    readonly numberFormat = "#,##0";

    taskPanelItems = [
        { text: 'Pallet Count', value: CountType.PalletCount },
        { text: 'Material Count', value: CountType.MaterialCount },
        { text: 'Distinct Bins Used', value: CountType.DistinctBinsUsed },
    ];
    selectedIndex = 0;
    selectedCountType = this.taskPanelItems[0].value;

    dataSource = this.dataSources.countsPerStorageType(this.selectedCountType);

    async tabValueChange(e: any) {
        this.selectedIndex = e.itemIndex;
        this.selectedCountType = e.itemData.value;
        this.dataSource = this.dataSources.countsPerStorageType(this.selectedCountType);
        await this.dataGrid.instance.refresh();
    }

    protected override exportName: string = "CountsPerStorageType";

    protected override filterConfig: FilterConfig[] = [
        {field: 'date', op: '>='},
        {field: 's203', op: '>='},
        {field: 's226', op: '>='},
        {field: 's219', op: '>='},
        {field: 's213', op: '>='},
        {field: 's216', op: '>='},
        {field: 's230', op: '>='},
        {field: 's20B', op: '>='},
        {field: 's236', op: '>='},
        {field: 's209', op: '>='},
        {field: 's200', op: '>='},
        {field: 's202', op: '>='},
        {field: 's220', op: '>='},
        {field: 's260', op: '>='},
        {field: 's204', op: '>='},
        {field: 's212', op: '>='},
        {field: 's210', op: '>='},
        {field: 's955', op: '>='},
        {field: 's999', op: '>='},
    ];
}
